import classNames from 'classnames'
import * as dateFns from 'date-fns'
import { ShortInterestData } from 'finviz-charts/app/models/quote/financialAttachmentsData'
import { dateFromUnixTimestamp } from 'finviz-charts/app/utils'
import * as React from 'react'

import { Heading } from '../../components'
import { Table, TableAlign, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/Table'
import { shortFormatNumber } from '../../util'

interface Props {
  shortInterests: ShortInterestData[]
}

const COMMON_CELL_PROPS = {
  align: TableAlign.Right,
  className: 'px-3.5 py-1',
  hasPadding: false,
  hasLeading: false,
}

export function ShortInterestTable({ shortInterests }: Props) {
  const shortInterestsDesc = React.useMemo(
    () => [...shortInterests].sort((a, b) => b.timestamp - a.timestamp),
    [shortInterests]
  )
  return (
    <div>
      <Heading level={4} className="my-0 text-muted">
        Short Interest History
      </Heading>
      <Table className="financials-table table-fixed leading-4 [overflow-anchor:none]">
        <TableHead>
          <TableHeader align={TableAlign.Left} className="px-3.5">
            Settlement Date
          </TableHeader>
          <TableHeader align={TableAlign.Right} className="px-3.5">
            Short Interest
          </TableHeader>
          <TableHeader align={TableAlign.Right} className="px-3.5">
            Avg. Daily Volume
          </TableHeader>
          <TableHeader align={TableAlign.Right} className="px-3.5">
            Short Float
          </TableHeader>
          <TableHeader align={TableAlign.Right} className="px-3.5">
            Short Ratio
          </TableHeader>
        </TableHead>
        <TableBody>
          {shortInterestsDesc.map(({ timestamp, shortInterest, sharesFloat, averageVolume }, index, arr) => (
            <TableRow
              key={timestamp}
              className={classNames('is-top-border hoverable-section !cursor-default', {
                'is-top-radius': index === 0,
                'is-bottom-border is-bottom-radius': index === arr.length - 1,
              })}
            >
              <TableCell {...COMMON_CELL_PROPS} align={TableAlign.Left}>
                {dateFns.format(dateFromUnixTimestamp(timestamp), 'MMM dd, yyy')}
              </TableCell>
              <TableCell {...COMMON_CELL_PROPS}>
                {shortFormatNumber(shortInterest, { fractions: 2, multiply: 1_000_000 })}
              </TableCell>
              <TableCell {...COMMON_CELL_PROPS}>{shortFormatNumber(averageVolume, { fractions: 2 })}</TableCell>
              <TableCell {...COMMON_CELL_PROPS}>
                {shortInterest !== null && sharesFloat !== null
                  ? `${shortFormatNumber((shortInterest / sharesFloat) * 100, { fractions: 2 })}%`
                  : '-'}
              </TableCell>
              <TableCell {...COMMON_CELL_PROPS}>
                {shortInterest !== null && averageVolume !== null
                  ? shortFormatNumber((shortInterest / averageVolume) * 1_000_000, { fractions: 2 })
                  : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
